import MapCache from './_MapCache';
import setCacheAdd from './_setCacheAdd';
import setCacheHas from './_setCacheHas';

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values ? values.length : 0;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

export default SetCache;



//////////////////
// WEBPACK FOOTER
// ../ckeditor5-utils/src/lib/lodash/_SetCache.js
// module id = null
// module chunks = 